import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/dist/ScrollTrigger"

const gsapProductFixed = {};

gsapProductFixed.init = () => {
    gsap.registerPlugin(ScrollTrigger);

    let fixedElem = ".js-gsap-fixed-ecommerce-product";

    if (document.querySelector(fixedElem)) {

        let sceneIntro;

        ScrollTrigger.matchMedia({
            // desktop
            "(min-width: 1024px)": function() {

                sceneIntro = function() {
                    let tl = gsap.timeline({
                        scrollTrigger: {
                            trigger: 'body',
                            endTrigger: ".js-gsap-container-ecommerce-product",
                            start: "top top",
                            end: "bottom bottom",
                            pin: fixedElem,
                            scrub: 1,
                            pinSpacing: false,
                            // markers: true
                        }
                    });
                    tl.to(fixedElem, {
                        duration: 1
                    });
                    return tl;
                }

                let masterTimeline = gsap.timeline()
                    .add(sceneIntro())

            }

            // Do nothig below 1024px

        })

    }

};

export default gsapProductFixed;
